import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DashboardPage = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate('/login', { replace: true });
      return;
    }
    const role = userProfile?.role ?? userProfile?.role ?? 'user';
    if (role === 'service_provider') {
      navigate('/dashboard/profile', { replace: true });
    } else {
      navigate('/dashboard/find', { replace: true });
    }
  }, [user, userProfile, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="animate-spin rounded-full h-12 w-12 border-2 border-brand-pink border-t-transparent" />
    </div>
  );
};

export default DashboardPage;
